import { useState } from 'react';
import TabNavigation from '../General/TabNavigation';
import Importar from './Importar';
import Notas from './Notas';

const Entrada = () => {
    const [activeTab, setActiveTab] = useState("Importar");

    const tabs = [
        { key: "Importar", label: "Importar", icon: "file", content: <Importar /> },
        { key: "Notas Fiscais", label: "Notas Fiscais", icon: "list", content: <Notas /> }
    ];

    return (
        <div className="w-full min-h-full">
            <TabNavigation
                tabs={tabs}
                activeTab={activeTab}
                onTabChange={setActiveTab}
                variant="default"
            />
        </div>
    );
};

export default Entrada;
